import React, { useState } from 'react'
import { Checkbox } from 'antd'
import SearchInput from 'components/SearchInput'
import { CompanyListDiv } from '../../../style'
import { Wrapper } from '../../../../JobRoles/PageHeader/JobRoleFilter/style'

const CompanyFilter = ({
  selectedCompany,
  handleCompanyCheckboxChange,
  companyData,
  companySearchValue,
  setCompanySearchValue,
  handleCompanySearch,
}) => {
  return (
    <div>
      <CompanyListDiv>
        <Wrapper>
          <SearchInput
            width={'90%'}
            placeholder="Search for the company"
            bordered={true}
            searchValue={companySearchValue}
            setSearchValue={setCompanySearchValue}
            handleCompanySearch={handleCompanySearch}
          />
        </Wrapper>

        {companyData.map(company => {
          return (
            <Checkbox
              style={{ margin: '0px' }}
              key={company}
              onChange={() => handleCompanyCheckboxChange(company.company_ids)}
              // checked={selectedCompany?.includes(company?.company_ids)}
              checked={selectedCompany
                .flat()
                .some(id => company.company_ids?.includes(id))}
            >
              {company.company_name}
            </Checkbox>
          )
        })}
      </CompanyListDiv>
    </div>
  )
}

export default CompanyFilter
